import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { fetchFlowcharts, createFlowchart, deleteFlowchart, createFlowchartComp } from "../../store/actions/flowchartActions";
import { LuPlus } from "react-icons/lu";
import { BsThreeDots } from "react-icons/bs";
import { compose } from "redux";
import { connect } from "react-redux";
import "react-confirm-alert/src/react-confirm-alert.css";
import "../WorkflowCreate.theme.css";

/* ---------- STABLE MODAL (themed) ---------- */
function Modal({ open, onClose, labelledBy, children, className = "", themeClass = "figma-theme" }) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby={labelledBy}
      aria-hidden={!open}
      className={
        `fixed inset-0 z-[9999] flex items-center justify-center transition-opacity ${themeClass} ` +
        (open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none")
      }
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div className="absolute inset-0 bg-black/40" />
      <div
        role="document"
        className={[
          "relative w-[92%] max-w-xl p-6 transition-transform",
          "rounded-[var(--radius)] shadow-2xl",
          "bg-[var(--card)] text-[var(--card-foreground)]",
          "border border-[color:var(--border)]",
          open ? "scale-100" : "scale-95",
          className,
        ].join(" ")}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
/* ------------------------------------------- */

const Workflows = (props) => {
  const {
    fetchFlowchartsFN,
    createFlowchartFN,
    deleteFlowchartFN,
    createFlowchartCompFN,
    activeDepartmentId,
    activeComplianceId,
    flowcharts,
    loading,
    error,
    user_id,
  } = props;

  const { t } = useTranslation();
  const history = useHistory();
  const [isDropdownOpen, setIsDropdownOpen] = useState(null);
  const [showCreate, setShowCreate] = useState(false);
  const [newName, setNewName] = useState("");
  const [newWorkflow, setNewWorkflow] = useState({
    name: "",
    description: "",
    owner: "",
    nodeCount: 0,
    status: "draft",
  });

  const [dateFilter, setDateFilter] = useState("any");   // "any" | "7d" | "30d" | "90d"
  const [ownerFilter, setOwnerFilter] = useState("All"); // "All" | "Mine"

  const [viewMode, setViewMode] = useState("grid"); // "grid" | "table"
  const [searchQuery, setSearchQuery] = useState("");

 const filteredFlowcharts = React.useMemo(() => {
  const list = Array.isArray(flowcharts) ? flowcharts : [];
  const q = (searchQuery || "").toLowerCase().trim();

  if (!q) return list;

  return list.filter(fc =>
    (fc.name || "").toLowerCase().includes(q)
  );
}, [flowcharts, searchQuery]);



  const [confirmDeleteId, setConfirmDeleteId] = useState(null);

  useEffect(() => {
    if (activeComplianceId) fetchFlowchartsFN(null, activeComplianceId);
  }, [activeComplianceId, fetchFlowchartsFN]);

  const confirmCreate = async () => {
    if (!newName.trim()) return;
    ////console.log("userId ", user_id)
    const created = await createFlowchartCompFN({
      name: newName.trim(),
      compliance: activeComplianceId,
      user_id: user_id
    });
    setShowCreate(false);
    if (created?.id) {
      history.push(`/edit/${created.id}`, { activeMenuItem: "editor" });
    }
  };

  const handleEditFlowchart = (id) => history.push(`/edit/${id}`, {isComp : true});
  const askDeleteFlowchart = (id) => setConfirmDeleteId(id);
  const confirmDelete = async () => {
    if (!confirmDeleteId) return;
    await deleteFlowchartFN(confirmDeleteId);
    setConfirmDeleteId(null);
  };


const matchesDateFilter = (fc) => {
  // ­şöü pick the real date field here:
  const raw = fc.updated_at || fc.created_at || fc.date;
  if (!raw) return true;

  const itemDate = new Date(raw);
  if (Number.isNaN(itemDate.getTime())) return true;

  const now = new Date();
  const diffMs = now.getTime() - itemDate.getTime();
  const diffDays = diffMs / (1000 * 60 * 60 * 24);

  if (dateFilter === "7d") return diffDays <= 7;
  if (dateFilter === "30d") return diffDays <= 30;
  if (dateFilter === "90d") return diffDays <= 90;
  return true; // "any"
};

// ­şæç Put this near matchesDateFilter
const matchesOwnerFilter = (fc) => {
  if (ownerFilter === "All") return true;

  // ­şöğ 1) Decide what the "owner" field really is for a workflow
  // Example possibilities:
  //   fc.owner_name     ÔåÆ "Mustafa Gunes"
  //   fc.owner          ÔåÆ "Mustafa Gunes"
  //   fc.ownerEmail     ÔåÆ "mustafa@company.com"
  //   fc.created_by     ÔåÆ "user123"
  //
  // Pick ONE and plug it below:
  const owner = fc.owner_name || fc.owner || fc.created_by || "";

  if (ownerFilter === "Mine") {
    // ­şöğ 2) Define how to recognize "me"
    // For now, simplest version: treat any non-empty owner as "mine"
    // (so you can at least see the filter doing something)
    //
    // If you want it to match a specific user later, change this to:
    //   return owner === CURRENT_USER_ID_OR_NAME;
    return !!owner;
  }

  return true;
};


const displayedFlowcharts = useMemo(
  () =>
    filteredFlowcharts.filter(
      (fc) => matchesDateFilter(fc) && matchesOwnerFilter(fc)
    ),
  [filteredFlowcharts, dateFilter, ownerFilter]
);


  

  if (!activeDepartmentId)
    return <div className="flex items-center justify-center h-full">Please select a department first</div>;
  if (loading)
    return <div className="flex items-center justify-center h-full">Loading...</div>;
  if (error)
    return <div className="text-red-500 text-center">Error: {error}</div>;

  return (
   <div className="h-[100dvh] w-full overflow-y-auto figma-theme figma-surface bg-[#F8F8F8]">
  <div className="mx-auto max-w-[1520px] px-6 lg:px-8 py-6">

    {/* Page heading */}
    <div className="mb-3">
      <h1 className="text-xl md:text-2xl font-medium tracking-wide text-[var(--foreground)]">
        {t("workflowManagement.title")}
      </h1>
      <p className="text-xs md:text-sm text-[var(--muted-foreground)]">
        {t("workflowManagement.subtitle")}
      </p>
    </div>

        <div className="flex flex-row">
 {/* Toolbar */}
<div className="w-full bg-[var(--card)] text-[var(--foreground)] border border-[color:var(--border)] rounded-[var(--radius)] px-4 py-4 md:py-5 flex flex-wrap items-center gap-4 md:gap-5 shadow-sm">
  {/* Left: Bigger Search */}
  <div className="flex-1 min-w-[320px] md:min-w-[400px]">
    <div className="relative">
      <input
        type="text"
        placeholder={t("workflowManagement.searchPlaceholder")}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="
          w-full
          h-10
          pl-9 pr-3
          rounded-md
          bg-[#F3F4F6]
          text-sm text-gray-800
          focus:outline-none
          focus:ring-0
          border-none
        "
        style={{
          boxShadow: "none",
          WebkitAppearance: "none",
        }}
      />

      {/* Search icon */}
      <svg
        className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M21 21l-4.35-4.35m1.85-5.15a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
    </div>
  </div>

  {/* Right side: filters + view toggle + create */}
  <div className="flex items-center gap-3 flex-wrap justify-end">
    {/* Filters group */}
  <div className="flex items-center gap-2">
  {/* Filter 1: Date */}
  <div className="relative">
    <svg
      className="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7 4v2M17 4v2M4 9h16M6 20h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H6A2 2 0 0 0 4 7v11a2 2 0 0 0 2 2z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    <select
      value={dateFilter}
      onChange={(e) => setDateFilter(e.target.value)}
      className="
        appearance-none
        bg-[#F3F4F6]
        rounded-md
        text-xs md:text-sm
        pl-8 pr-6 py-2
        border-none
        focus:outline-none
        focus:ring-0
      "
    >
      <option value="any">{t("workflowManagement.dateFilter.any")}</option>
      <option value="7d">{t("workflowManagement.dateFilter.last7d")}</option>
      <option value="30d">{t("workflowManagement.dateFilter.last30d")}</option>
      <option value="90d">{t("workflowManagement.dateFilter.last90d")}</option>
    </select>

    <svg
      className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" />
    </svg>
  </div>
</div>


    {/* View toggle with icons + text (black active style) */}
    <div className="flex items-center rounded-md border border-[color:var(--border)] overflow-hidden">
      <button
        type="button"
        onClick={() => setViewMode('grid')}
        title="Grid view"
        className={`flex items-center gap-1 px-3.5 py-1.5 text-sm transition-colors duration-150
          ${
            viewMode === 'grid'
              ? 'bg-black text-white font-medium'
              : 'bg-[var(--card)] text-[var(--muted-foreground)] hover:bg-black/80 hover:text-white'
          }`}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M4 4h7v7H4V4zm9 0h7v7h-7V4zM4 13h7v7H4v-7zm9 0h7v7h-7v-7z" />
        </svg>
        {t("workflowManagement.view.grid")}
      </button>

      <button
        type="button"
        onClick={() => setViewMode('table')}
        title="Table view"
        className={`flex items-center gap-1 px-3.5 py-1.5 text-sm border-l border-[color:var(--border)] transition-colors duration-150
          ${
            viewMode === 'table'
              ? 'bg-black text-white font-medium'
              : 'bg-[var(--card)] text-[var(--muted-foreground)] hover:bg-black/80 hover:text-white'
          }`}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6h18M3 12h18M3 18h18" />
        </svg>
        {t("workflowManagement.view.table")}
      </button>
    </div>

    {/* Create Workflow button */}
    <button
      className="flex items-center justify-center gap-1 h-8 px-3 rounded-md bg-[var(--primary)] text-[var(--primary-foreground)] text-sm border border-[color:var(--border)] hover:opacity-90 transition"
      onClick={() => {
        if (!activeComplianceId) return alert('Please select a department first');
        setNewName('');
        setShowCreate(true);
      }}
    >
      <LuPlus className="w-4 h-4" />
      <span className="hidden sm:inline">{t("workflowManagement.addWorkflow")}</span>
    </button>
  </div>
</div>



        </div>

        {/* Content */}
        <div className="w-full mt-4 pb-24">
          {(!displayedFlowcharts || displayedFlowcharts?.length === 0) ? (
            <div className="text-center text-[var(--muted-foreground)]">
              No workflows match your search.
            </div>
          ) : (
            <>
              {viewMode === "grid" ? (
                /* GRID / DRAG VIEW */
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                  {displayedFlowcharts.map((flowchart) => {
                    const daysSince = Math.floor(
                      (Date.now() - new Date(flowchart.created_at)) / (1000 * 60 * 60 * 24)
                    );

                    return (
                      <div
                        key={flowchart.id}
                        className="border border-[color:var(--border)] rounded-xl shadow-lg p-4 bg-[var(--card)] text-[var(--foreground)] relative w-full cursor-pointer hover:shadow-xl transition-all hover:-translate-y-0.5"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleEditFlowchart(flowchart.id);
                        }}
                      >
                        {/* Header row */}
                        <div className="flex justify-between items-start">
                          <h2 className="text-base mb-2 line-clamp-1">{flowchart.name}</h2>
                          <div className="relative">
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setIsDropdownOpen(isDropdownOpen === flowchart.id ? null : flowchart.id);
                              }}
                              className="p-1.5 hover:bg-[var(--accent)] rounded-full"
                            >
                              <BsThreeDots className="w-4 h-4 text-[var(--muted-foreground)]" />
                            </button>
                            {isDropdownOpen === flowchart.id && (
                              <div
                                className="absolute right-0 mt-1 w-36 bg-[var(--card)] border border-[color:var(--border)] rounded-md shadow-md z-50"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleEditFlowchart(flowchart.id);
                                    setIsDropdownOpen(null);
                                  }}
                                  className="block w-full text-left px-3 py-1.5 text-xs hover:bg-[var(--accent)]"
                                >
                                  Edit
                                </button>
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    askDeleteFlowchart(flowchart.id);
                                    setIsDropdownOpen(null);
                                  }}
                                  className="block w-full text-left px-3 py-1.5 text-xs text-[var(--destructive)] hover:bg-[var(--accent)]"
                                >
                                  Delete
                                </button>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Meta info */}
                        <div className="flex flex-col gap-2 mt-3 text-sm text-[var(--muted-foreground)]">
                          {/* Owner (new standard person icon) */}
                          <div className="flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M12 12a4 4 0 100-8 4 4 0 000 8z" />
                              <path strokeLinecap="round" strokeLinejoin="round" d="M4 20a8 8 0 0116 0" />
                            </svg>
                            <span>{flowchart.owner_name}</span>
                          </div>

                          {/* Nodes (new workflow/flowchart icon) */}
                          <div className="flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                              {/* Top box */}
                              <rect x="14" y="3" width="6" height="4" rx="1" ry="1" />
                              {/* Middle box */}
                              <rect x="4" y="10" width="6" height="4" rx="1" ry="1" />
                              {/* Bottom box */}
                              <rect x="14" y="17" width="6" height="4" rx="1" ry="1" />
                              {/* Connectors */}
                              <path d="M10 12h4M17 7v3M17 14v3" />
                            </svg>
                            <span>
                              {t("workflowManagement.card.nodesCount", {
                                count: flowchart.nodes?.length || 0,
                              })}
                            </span>
                          </div>

                          {/* Created */}
                          <div className="flex items-center gap-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-4 h-4 text-[var(--muted-foreground)]"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                              />
                            </svg>
                            <span>
                              {daysSince === 0
                                ? t("workflowManagement.card.createdToday")
                                : daysSince === 1
                                  ? t("workflowManagement.card.dayAgo", {
                                      count: daysSince,
                                    })
                                  : t("workflowManagement.card.daysAgo", {
                                      count: daysSince,
                                    })}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                /* STACKED CARD VIEW (replaces TABLE) */
                <div className="space-y-3">
                  {displayedFlowcharts.map((fc) => (
                    <div
                      key={fc.id}
                      onClick={(e) => {
                        e.preventDefault(); e.stopPropagation();
                        handleEditFlowchart(fc.id);
                      }}
                      className="relative flex items-start justify-between gap-4 rounded-lg border border-[color:var(--border)] bg-[var(--card)] p-4 min-h-[72px] hover:shadow-md transition cursor-pointer"
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          handleEditFlowchart(fc.id);
                        }
                      }}
                    >
                      {/* Left side: name + owner + meta */}
                      <div className="min-w-0">
                        {/* Name */}
                        <div className="flex items-center gap-2">
                          <span className="text-sm font-medium text-[var(--foreground)] line-clamp-1">
                            {fc.name}
                          </span>
                          {fc.status && (
                            <span className="shrink-0 rounded px-1.5 py-0.5 text-[10px] border border-[color:var(--border)] text-[var(--muted-foreground)]">
                              {fc.status}
                            </span>
                          )}
                        </div>

                        {/* Owner (matches grid viewÔÇÖs owner) */}
                        <div className="mt-1 flex items-center gap-2 text-[var(--muted-foreground)]">
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 12a4 4 0 100-8 4 4 0 000 8z" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4 20a8 8 0 0116 0" />
                          </svg>
                          <span className="text-xs">{fc.owner_name}</span>
                        </div>

                        {/* Meta row */}
                        <div className="mt-1.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-[var(--muted-foreground)]">
                          {/* Created */}
                          <span className="inline-flex items-center gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                              <path strokeLinecap="round" d="M16 2v3M8 2v3M4 7h16M5 22h14a2 2 0 0 0 2-2V7H3v13a2 2 0 0 0 2 2z" />
                            </svg>
                            {new Date(fc.created_at).toLocaleDateString()}
                          </span>

                          {/* Nodes */}
                          <span className="inline-flex items-center gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                              <rect x="14" y="3" width="6" height="4" rx="1" ry="1" />
                              <rect x="4" y="10" width="6" height="4" rx="1" ry="1" />
                              <rect x="14" y="17" width="6" height="4" rx="1" ry="1" />
                              <path d="M10 12h4M17 7v3M17 14v3" />
                            </svg>
                            {t("workflowManagement.card.nodesCount", {
                              count: fc.nodes?.length || 0,
                            })}
                          </span>
                        </div>
                      </div>

                      {/* Right side: actions (3-dots) */}
                      <div className="relative shrink-0" onClick={(e) => e.stopPropagation()}>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setIsDropdownOpen(isDropdownOpen === fc.id ? null : fc.id);
                          }}
                          className="p-1.5 hover:bg-[var(--accent)] rounded-full"
                        >
                          <BsThreeDots className="w-4 h-4 text-[var(--muted-foreground)]" />
                        </button>

                        {isDropdownOpen === fc.id && (
                          <div
                            className="absolute right-0 mt-1 w-36 bg-[var(--card)] border border-[color:var(--border)] rounded-md shadow-md z-50"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleEditFlowchart(fc.id);
                                setIsDropdownOpen(null);
                              }}
                              className="block w-full text-left px-3 py-1.5 text-xs hover:bg-[var(--accent)]"
                            >
                              Edit
                            </button>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                askDeleteFlowchart(fc.id);
                                setIsDropdownOpen(null);
                              }}
                              className="block w-full text-left px-3 py-1.5 text-xs text-[var(--destructive)] hover:bg-[var(--accent)]"
                            >
                              Delete
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>


              )}
            </>
          )}
          <div style={{ height: "20px" }} />
        </div>

        {/* CREATE MODAL */}
        <Modal open={showCreate} onClose={() => setShowCreate(false)} labelledBy="create-workflow-title">
          <h2 id="create-workflow-title" className="text-xl font-semibold mb-2 text-[var(--foreground)]">
            {t("workflowManagement.createModal.title")}
          </h2>

          <label className="block text-sm mb-1 text-[var(--foreground)]">
            {t("workflowManagement.createModal.name")}
          </label>
          <input
            type="text"
            value={newName ?? ""}
            onChange={(e) => setNewName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && confirmCreate()}
            className="w-full border border-[color:var(--border)] rounded-md px-3 py-2 bg-[var(--input-background)] text-[var(--foreground)] focus:outline-none focus:ring-2 focus:ring-[color:var(--ring)] mb-5"
            placeholder={t("workflowManagement.createModal.namePlaceholder")}
          />

          <div className="grid grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-sm mb-1 text-[var(--foreground)]">
                {t("workflowManagement.createModal.owner")}
              </label>
              <input
                type="text"
                value={newWorkflow.owner ?? ""}
                onChange={(e) => setNewWorkflow((prev) => ({ ...prev, owner: e.target.value }))}
                placeholder={t("workflowManagement.createModal.ownerPlaceholder")}
                className="w-full border border-[color:var(--border)] rounded-md px-3 py-2 bg-[var(--input-background)] text-[var(--foreground)] focus:outline-none focus:ring-2 focus:ring-[color:var(--ring)]"
              />
            </div>
            <div>
              <label className="block text-sm mb-1 text-[var(--foreground)]">
                {t("workflowManagement.createModal.numberOfNodes")}
              </label>
              <input
                type="number"
                value={Number.isFinite(newWorkflow.nodeCount) ? newWorkflow.nodeCount : 0}
                onChange={(e) =>
                  setNewWorkflow((prev) => ({
                    ...prev,
                    nodeCount: Number(e.target.value) || 0,
                  }))
                }
                placeholder={t("workflowManagement.createModal.nodeCountPlaceholder")}
                className="w-full border border-[color:var(--border)] rounded-md px-3 py-2 bg-[var(--input-background)] text-[var(--foreground)] focus:outline-none focus:ring-2 focus:ring-[color:var(--ring)]"
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="block text-sm mb-1 text-[var(--foreground)]">
              {t("workflowManagement.createModal.description")}
            </label>
            <textarea
              value={newWorkflow.description ?? ""}
              onChange={(e) => setNewWorkflow((prev) => ({ ...prev, description: e.target.value }))}
              rows={3}
              placeholder={t("workflowManagement.createModal.descriptionPlaceholder")}
              className="w-full border border-[color:var(--border)] rounded-md px-3 py-2 bg-[var(--input-background)] text-[var(--foreground)] focus:outline-none focus:ring-2 focus:ring-[color:var(--ring)]"
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm mb-1 text-[var(--foreground)]">
              {t("workflowManagement.createModal.status")}
            </label>
            <select
              value={newWorkflow.status ?? "draft"}
              onChange={(e) => setNewWorkflow((prev) => ({ ...prev, status: e.target.value }))}
              className="w-full border border-[color:var(--border)] rounded-md px-3 py-2 bg-[var(--input-background)] text-[var(--foreground)] focus:outline-none focus:ring-2 focus:ring-[color:var(--ring)]"
            >
              <option value="draft">{t("workflowManagement.createModal.statusDraft")}</option>
              <option value="active">{t("workflowManagement.createModal.statusActive")}</option>
              <option value="archived">{t("workflowManagement.createModal.statusArchived")}</option>
            </select>
          </div>

          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={() => setShowCreate(false)}
              className="px-4 py-2 rounded-md border border-[color:var(--border)] text-[var(--foreground)] hover:bg-[var(--accent)]"
            >
              {t("workflowManagement.createModal.cancel")}
            </button>
            <button
              type="button"
              onClick={confirmCreate}
              disabled={!String(newName ?? "").trim()}
              className="px-4 py-2 rounded-md bg-[var(--primary)] text-[var(--primary-foreground)] hover:opacity-90 disabled:opacity-50"
            >
              {t("workflowManagement.createModal.create")}
            </button>
          </div>
        </Modal>

        {/* DELETE CONFIRM MODAL */}
        <Modal open={!!confirmDeleteId} onClose={() => setConfirmDeleteId(null)} labelledBy="confirm-delete-title">
          <h2 id="confirm-delete-title" className="text-xl font-semibold mb-3 text-[var(--foreground)]">
            Confirm Delete
          </h2>
          <p className="text-[var(--muted-foreground)] mb-6">
            Are you sure you want to delete this workflow?
          </p>
          <div className="flex justify-end gap-3">
            <button
              onClick={() => setConfirmDeleteId(null)}
              className="px-4 py-2 rounded-md border border-[color:var(--border)] text-[var(--foreground)] hover:bg-[var(--accent)]"
            >
              Cancel
            </button>
            <button
              onClick={confirmDelete}
              className="px-4 py-2 rounded-md bg-[var(--destructive)] text-[var(--destructive-foreground)] hover:opacity-90"
            >
              Delete
            </button>
          </div>
        </Modal>

      </div>
    </div>
  );
};

/* Redux wiring */
const mapStateToProps = (state) => {
  //console.log(state)
  return {
    token: state.auth.token,
    activeDepartmentId: state.department.activeDepartmentId,
    flowcharts: state.workflows.flowcharts,
    newWorkflow: state.workflows.currentFlowchart,
    loading: state.workflows.loading,
    error: state.workflows.error,
    user_id: state.profile.profile?.user_id,
    activeComplianceId: state.compliance.activeComplianceId
    }
};

const mapDispatchToProps = (dispatch) => ({
    fetchFlowchartsFN: (dID, cID) => dispatch(fetchFlowcharts(dID, cID)),
    createFlowchartFN: (data) => dispatch(createFlowchart(data)),
    createFlowchartCompFN: (data) => dispatch(createFlowchartComp(data)),
    deleteFlowchartFN: (ID) => dispatch(deleteFlowchart(ID)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Workflows);